/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createSQRT2 } from '../../factoriesAny.js';
export var SQRT2Dependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createSQRT2: createSQRT2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSQRT2.generated.js
// module id = 1640
// module chunks = 0